import { makeStyles, createStyles } from '@material-ui/core/styles';
import type { Theme } from '@material-ui/core/styles';

const styles = (theme: Theme) =>
    createStyles({
        /* Styles applied to the root element. */
        root: {},
        outlinedInfo: {
            boxShadow: 'none',
            borderColor: theme.palette.info.main,
            backgroundColor: 'transparent',
        },
        outlinedWarning: {
            boxShadow: 'none',
            borderColor: theme.palette.warning.main,
            backgroundColor: 'transparent',
        },
        outlinedError: {
            boxShadow: 'none',
            borderColor: theme.palette.error.main,
            backgroundColor: 'transparent',
        },
        outlinedSuccess: {
            boxShadow: 'none',
            borderColor: theme.palette.success.main,
            backgroundColor: 'transparent',
        },
        defaultInfo: {
            color: theme.palette.info.contrastText,
            borderColor: 'transparent',
            backgroundColor: theme.palette.info.main,
        },
        defaultWarning: {
            color: theme.palette.info.contrastText,
            borderColor: 'transparent',
            backgroundColor: theme.palette.warning.main,
        },
        defaultError: {
            color: theme.palette.info.contrastText,
            borderColor: 'transparent',
            backgroundColor: theme.palette.error.main,
        },
        defaultSuccess: {
            color: theme.palette.info.contrastText,
            borderColor: 'transparent',
            backgroundColor: theme.palette.success.main,
        },
        disabled: {},
    });

export default makeStyles(styles, { name: 'MuiTimelineDot' });
